<template>
	<div class="zyWrap">
		<div class="minixx">
			<div class="title">众享乐核销系统MINI版</div>
			<div class="tc" @click="tc">退出</div>
			<div class="myXX">
				<img class="tx" :src="myDetails.logoImgUrl?myDetails.logoImgUrl:require('../assets/login/userAvatar.png')" alt="">
				<div class="name">{{myDetails.name?myDetails.name:'众享乐用户'}}</div>
			</div>
			<div class="hdxx">
				<div class="list">
					<div class="name">余额</div>
					<div class="val">{{priceDetails.totalMoney?(priceDetails.totalMoney/100).toFixed(2):0}}</div>
				</div>
				<div class="list">
					<div class="name">可提现</div>
					<div class="val">{{priceDetails.canOutMoney?(priceDetails.canOutMoney/100).toFixed(2):0}}</div>
				</div>
				<div class="list">
					<div class="name">活动</div>
					<div class="val">{{hdslDetails?hdslDetails:0}}</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="numxx">
				<div class="list" @click="wkf">
					<div class="name">
						<img class="img" src="../assets/index/pthx.png" alt="">
						<div class="text">平台核销</div>
					</div>
					<!-- <div class="val">56</div> -->
				</div>
				<div class="shu"></div>
				<div class="list" @click="wkf">
					<div class="name">
						<img class="img" src="../assets/index/fxhx.png" alt="">
						<div class="text">分享核销</div>
					</div>
					<!-- <div class="val">56</div> -->
				</div>
				<div class="shu"></div>
				<div class="list" @click="wkf">
					<div class="name">
						<img class="img" src="../assets/index/fxsl.png" alt="">
						<div class="text">分享数量</div>
					</div>
					<!-- <div class="val">56</div> -->
				</div>
			</div>
			<div class="search">
				<div class="l">
					<img class="img" src="../assets/index/fdj.png" alt=""><input class="val" type="text" placeholder="请输入订单号" v-model="codeKey">
					<div class="btn" @click="submit">查询</div>
				</div>
				<div class="r" @click="saoma">
					<img src="../assets/index/sm.png" alt="">
				</div>
			</div>
			<div class="searchList" v-show="showa">
				<div class="list">
					<img :src="smDetailsa.imgUrlSquare" alt="">
					<div class="listMain">
						<div class="name">{{smDetailsa.name}}</div>
						<div class="xspt">销售平台：{{(smDetailsa.copperName)?smDetailsa.copperName:'众享乐'}}</div>
						<div class="bz">备注：{{smDetailsa.couponRemark?smDetailsa.couponRemark:''}}</div>
						<div class="btnWrap">
							<div class="btn" @click="showa = false">取消</div>
							<div class="btn" @click="successa(smDetailsa)" v-if="smDetailsa.useState === 1 ">兑换</div>
							<div class="btn" v-else>已兑换</div>
						</div>
					</div>
					<img class="yqh" src="../assets/index/done.png" alt="">
				</div>
			</div>
		</div>
		<van-popup v-model="show" class="orderBoxWrap" :close-on-click-overlay='false'>
			<img class="dbj" src="../assets/index/orderBac.png" alt="">
			<img class="yqh" v-if="smDetails.useState == 101" src="../assets/index/done.png" alt="">
			<div class="orderBox">
				<div class="orderBoxheader">确认出货</div>
				<div class="main">
					<div class="left">
						<img :src="smDetails.imgUrlSquare" alt="">
						<!-- <span>{{ tag }}</span> -->
					</div>
					<div class="right">
						<p>单号 : {{ smDetails.outTradeNo }}</p>
						<p>促销名称 : {{ smDetails.name}}</p>
						<p>促销价格 : ￥{{ smDetails.price/100 }}</p>
						<p>用户昵称 : {{ smDetails.userNickName?smDetails.userNickName : '众享乐用户' }}</p>
					</div>
				</div>
				<div class="footer">
					<div @click="show = false">取消</div>
					<div @click="success">确认</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import wx from 'weixin-js-sdk';
	import sha1 from "js-sha1";
	import {
		Base64
	} from 'js-base64'
	export default {
		name: 'HelloWorld',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App',
				tempNum: '',
				url: '',
				show: false,
				smDetails: '',
				nrDetails: '',
				codeKey: '',
				showa: false,
				smDetailsa: '',
				myDetails: '',
				priceDetails: '',
				hdslDetails: ''
			}
		},
		methods: {
			wxLogin() {
				var test = window.location.href.split('#')[0]
				// var test = 'http://f.chnzxl.com/index11.html'
				const url = 'https://j.chnzxl.com/entryc/wxTool/getJsTicket'
				this.$http({
					url: url,
					method: 'post',
					data: this.$http.adornData({}, url, true)
				}).then(({
					data
				}) => {
					var appid = 'wx56af4aa57f0af06f'
					var jsapi_ticket = data.data
					var noncestr = this.sjs()
					var timestamp = Math.round(new Date() / 1000)
					// var url = 'https://j.chnzxl.com'
					// var urla = 'https://f.chnzxl.com/'
					var urla = test
					var signatureVal = 'jsapi_ticket=' + jsapi_ticket + '&noncestr=' + noncestr + '&timestamp=' + timestamp +
						'&url=' +
						urla + ''
					var signature = sha1(signatureVal)
					// console.log(jsapi_ticket, noncestr, timestamp, signatureVal, sha1(signatureVal))
					setTimeout(() => {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: appid, // 必填，公众号的唯一标识
							timestamp: String(timestamp), // 必填，生成签名的时间戳
							nonceStr: String(noncestr), // 必填，生成签名的随机串
							signature: String(signature), // 必填，签名，见附录1
							jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
						});
						wx.ready(function() {
							console.log('成功')
							// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
						});
						wx.error(function(res) {
							console.log(res, '失败')
							// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
						});
					}, 1000)
				})
			},
			sjs() {
				let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
					'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e',
					'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
				]
				let nums = ""
				for (let i = 0; i < 16; i++) { //这里是几位就要在这里不改变
					let id = parseInt(Math.random() * 61)
					nums += chars[id]
				}
				return nums
			},
			saoma() {
				var that = this
				wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success: function(res) {
						//扫码后获取结果参数赋值给Input
						var url = res.resultStr
						that.dataChange(Base64.decode(url))
					}
				})
			},
			tc() {
				window.localStorage.clear()
				if (!localStorage.getItem('uid')) {
					this.$router.push({
						name: 'login'
					})
				}
			},
			dataChange(data) {
				var data = JSON.parse(data)
				this.nrDetails = data
				// 扫码获得商品详情
				const url = this.apiList.active.moduleDetail
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData({
						getId: data.getId
					}, url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.show = true
						this.smDetails = data.data
					} else {
						this.$toast(data.msg)
					}
				})
			},
			success() {
				let url = this.apiList.active.choose
				const formData = {
					activityGetId: this.nrDetails.getId,
					activityId: this.nrDetails.activityId,
					activityType: this.nrDetails.activityType,
					usrId: this.nrDetails.userId,
					shaPayKey: this.nrDetails.shaPayKey
				}
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData(formData, url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.show = false
						// MessageBox.alert('兑换成功')
						this.$toast('兑换成功', )
					} else {
						this.$toast(data.msg)
					}
				})
			},
			submit() {
				if (!this.codeKey) return this.$toast("请输入兑换码")
				const url = this.apiList.active.exchangeCode;
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData({
						codeKey: this.codeKey
					}, url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.showa = true
						this.smDetailsa = data.data
						// MessageBox.alert('兑换成功')
					} else {
						this.showa = false
						this.$toast(data.msg)
						if (data.msg === 'sign验证失败') {
							localStorage.clear()
							this.$toast('您的账号登录超时')
							setTimeout(() => {
								this.$router.push({
									name: 'login'
								})
							}, 1000)
						}
					}
				})
			},
			successa(data) {
				let url = this.apiList.active.choose
				const formData = {
					activityGetId: data.id,
					activityId: data.activityId,
					activityType: data.activityType,
					usrId: data.userId,
					codeKey: this.codeKey
				}
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData(formData, url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.show = false
						// MessageBox.alert('兑换成功')
						this.$toast('兑换成功', )
					} else {
						this.$toast(data.msg)
					}
				})
			},
			getData() {
				const url = this.apiList.shop.get
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData('', url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.myDetails = data.data
					} else {
						if (data.msg === 'sign验证失败') {
							localStorage.clear()
							this.$toast('您的账号登录超时')
							setTimeout(() => {
								this.$router.push({
									name: 'login'
								})
							}, 1000)
						}
					}
				})
			},
			getMoney() {
				const url = this.apiList.money.get
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData('', url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.priceDetails = data.data
					} else {
						if (data.msg === 'sign验证失败') {
							localStorage.clear()
							this.$toast('您的账号登录超时')
							setTimeout(() => {
								this.$router.push({
									name: 'login'
								})
							}, 1000)
						}
					}
				})
			},
			getHdsl() {
				const url = this.apiList.money.hdsl
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData('', url, true)
				}).then(({
					data
				}) => {
					if (data.result) {
						this.hdslDetails = data.data
						console.log(data.data)
					} else {
						if (data.msg === 'sign验证失败') {
							localStorage.clear()
							this.$toast('您的账号登录超时')
							setTimeout(() => {
								this.$router.push({
									name: 'login'
								})
							}, 1000)
						}
					}
				})
			},
			wkf() {
				this.$toast('暂未开放')
			}
		},
		created() {
			if (!localStorage.getItem('uid')) {
				this.$router.push({
					name: 'login'
				})
			} else {
				this.getData()
				this.wxLogin()
				this.getMoney()
				this.getHdsl()
				// var a =
				// 	'eyJ0eXBlIjoxMDEsImdldElkIjoxODgzMCwic2hhUGF5S2V5IjoiZWU1OGFmYTBlNTA1ZTc0ZjY0NTE1ODA1OWM4NGUzODYiLCJhY3Rpdml0eUlkIjoxMzg5LCJhY3Rpdml0eVR5cGUiOjMwMSwidXNlcklkIjoiMTAwOSJ9'
				// console.log(this.dataChange(Base64.decode(a)))
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.zyWrap {
		.minixx {
			background: url(../assets/index/dbj.png);
			background-size: 100% 100%;
			height: 3.74rem;
			padding-top: 0.2rem;
			position: relative;

			.title {
				text-align: center;
				font-size: 0.34rem;
				font-family: Adobe Heiti Std;
				font-weight: bold;
				color: #FFFFFF;
			}

			.tc {
				font-size: 0.26rem;
				font-family: Adobe Heiti Std;
				font-weight: bold;
				color: #FFFFFF;
				position: absolute;
				top: .25rem;
				right: .2rem;
			}

			.myXX {
				display: flex;
				padding: 0 0.88rem;
				align-items: center;
				margin-top: 0.48rem;

				.tx {
					width: 0.73rem;
					height: 0.73rem;
					margin-right: 0.1rem;
					border-radius: 50%;
				}

				.name {
					font-size: 0.32rem;
					font-family: PingFang SC;
					font-weight: bold;
					color: #FFFFFF;
					flex: 1;
					margin-right: .2rem;
				}
			}

			.hdxx {
				display: flex;
				justify-content: space-around;
				margin-top: 0.42rem;

				.list {
					display: flex;
					flex-direction: column;
					align-items: center;

					.name {
						font-size: 0.26rem;
						font-family: PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
					}

					.val {
						font-size: 0.3rem;
						font-family: PingFang SC;
						font-weight: bold;
						color: #FFFFFF;
						margin-top: 0.17rem;
					}
				}
			}
		}

		.content {
			padding: 0.3rem;

			.numxx {
				display: flex;
				background: #FFFFFF;
				border-radius: 14px;
				box-shadow: 0 0 .3rem 0.05rem #e0e0e0;
				align-items: center;
				justify-content: center;
				height: 1.13rem;

				.list {
					width: 33%;
					display: flex;
					flex-direction: column;
					align-items: center;

					.name {
						display: flex;
						align-items: center;

						.img {
							width: 0.31rem;
							height: 0.31rem;
							margin-right: 0.08rem;
						}

						.text {
							font-size: 0.24rem;
							font-family: PingFang SC;
							font-weight: bold;
							color: #333333;
						}
					}

					.val {
						margin-top: 0.11rem;
						font-size: 0.3rem;
						font-family: PingFang SC;
						font-weight: bold;
						color: #333333;
					}
				}

				.shu {
					width: 1px;
					height: 0.41rem;
					background: #000000;
				}
			}
		}

		.search {
			margin-top: 0.32rem;
			display: flex;
			justify-content: space-between;
			height: 0.59rem;

			.l {
				background-color: #fff;
				display: flex;
				align-items: center;
				padding: 0 0 0 0.24rem;
				border-radius: 0.3rem 0rem 0rem 0.3rem;
				border: 0.01rem solid #EEEEEE;
				background: #FFFFFF;
				flex: 1;

				.img {
					width: 0.27rem;
					height: 0.27rem;
					margin-right: 0.18rem;
				}

				.val {
					flex: 1;
					font-size: 0.24rem;
					font-family: PingFang SC;
					font-weight: 500;
					color: #999999;
					border: 0;
					outline: none;
				}

				.btn {
					width: 0.88rem;
					height: 100%;
					background: #FFAD00;
					font-size: 0.28rem;
					font-family: PingFang SC;
					font-weight: bold;
					color: #FFFFFF;
					text-align: center;
					line-height: .59rem;
				}
			}

			.r {
				background: #fff;
				width: 0.62rem;
				margin-left: 0.23rem;
				display: flex;
				justify-content: center;
				align-items: center;
				height: 100%;
				border-radius: .1rem;

				img {
					width: 0.37rem;
					height: 0.37rem;
				}
			}
		}

		.searchList {
			margin-top: .2rem;

			.list {
				background-color: #fff;
				display: flex;
				box-shadow: 0px 0.06rem 0.16rem 0px rgba(0, 0, 0, 0.1);
				border-radius: .16rem;
				position: relative;
				overflow: hidden;

				img {
					width: 2.14rem;
					height: 2.24rem;
				}

				.listMain {
					flex: 1;
					padding: .2rem;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					overflow: hidden;

					.name {
						font-size: 0.28rem;
						color: #333;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
					}

					.xspt {
						font-size: 0.24rem;
						color: #333;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
					}

					.bz {
						font-size: 0.24rem;
						color: #999;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
					}

					.btnWrap {
						display: flex;
						justify-content: flex-end;

						.btn {
							height: .5rem;
							font-size: 0.24rem;
							border: 1px solid #d7d7d7;
							border-radius: .25rem;
							padding: 0 0.24rem;
							margin-left: .3rem;
							line-height: .5rem;
						}

						.btn:last-child {
							border: 1px solid #E53935;
							color: #fff;
							background-color: #E53935;
						}
					}
				}

				.yqh {
					position: absolute;
					right: .2rem;
					bottom: .8rem;
					width: 1.4rem;
					height: 1.4rem;
					top: .1rem;
				}
			}
		}

		.saoma {
			font-size: 1rem;
			text-align: center;
		}

		.orderBoxWrap {
			background-color: initial;

			.dbj {
				width: 100%;
				height: 7.2rem;
				position: absolute;
			}

			.yqh {
				position: absolute;
				width: 2rem;
				bottom: 1.2rem;
				right: .4rem;
			}

			.orderBox {
				width: 5.68rem;
				min-height: 7.2rem;
				overflow: hidden;
				padding-bottom: .3rem;
				position: relative;

				.orderBoxheader {
					text-align: center;
					margin-top: 2.9rem;
					color: #333;
					font-size: .36rem;
				}

				.main {
					display: flex;
					width: 5.08rem;
					margin: .4rem auto 0;

					.left {
						width: .94rem;
						height: .98rem;
						margin-right: .14rem;
						border-radius: .14rem;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.right {
						overflow: hidden;

						p {
							color: #333333;
							margin-bottom: .18rem;
							font-size: .24rem;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						p:first-child {
							margin-top: 0;
						}
					}
				}

				.footer {
					display: flex;
					width: 5.08rem;
					margin: 0 auto;
					justify-content: space-between;
					margin-top: .2rem;

					div {
						width: 1.8rem;
						color: #999;
						border-radius: .68rem;
						height: .68rem;
						line-height: .68rem;
						text-align: center;
						font-size: .3rem;
						border: 1px solid #999;
					}

					div:last-child {
						border: 1px solid #E53935;
						color: #fff;
						background-color: #E53935;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue